import { red } from '@pelotoncycle/design-system'
import styled from 'styled-components'

export const StyledRemoveButton = styled.button.attrs({ type: 'button' })`
  cursor: pointer;
  display: block;
  text-decoration: underline;
  color: ${red[80]};
`
